












































































































import Vue from "vue";
// import { extensions } from '@/features/collage/const';
// eslint-disable-next-line import/no-extraneous-dependencies
// import { cloneDeep } from 'lodash';

export default Vue.extend({
    data() {
        return {
            extensions: [
                ".rvt",
                ".stl",
                ".obj",
                ".rfa",
                ".fbx",
                ".rft",
                ".dgn",
                ".sat",
                ".skp",
                ".3ds",
                ".3mf",
                ".dae",
                ".gim",
                ".ifc",
                ".dxf",
                ".dwg",
                ".pdf",
                ".doc",
                ".docx",
                ".xls",
                ".xlsx",
                ".ppt",
                ".pptx",
                ".png",
                ".jpg",
                ".jpeg",
                ".gif",
                ".txt",
                ".rar",
                ".7z",
                ".zip",
            ],
            isUploadStart: false,
        };
    },
    props: {
        onlyStandard: { type: Boolean },
        visible: { type: Boolean },
        fileList: { type: Array },
        uploadComplete: { type: Boolean },
        convertError: { type: Boolean },
        convertProgress: { type: Number },
        convertProgressText: { type: String }
    },
    methods: {
        startUpload(e) {
            const file = e.raw;
            const index = file.name.lastIndexOf(".");
            const type: string = file.name.slice(index);
            const uploadableExtensions = [".rvt"];
            if (!uploadableExtensions.some(v => v === type.toLowerCase())) {
                this.$message.warning(
                    `暂时不支持该格式, 请上传${uploadableExtensions.join(" ")}文件`
                );
                return;
            }
            this.isUploadStart = true;
            this.$emit("handleFileUploadChange", e);
        },
        handleUploadFileDelete(file) {
            this.$emit('handleUploadFileDelete', file.uid);
            this.isUploadStart = false;
        },
        handleDataUploadFileDelete(file) {
            this.$emit('handleDataUploadFileDelete', file.uid);
        },
    },
    created() {
        console.log(this.onlyStandard);
    }
});
